import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ light = false, className = "" }) => {
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} aria-label="Bond Collective home">
      <img
        src="/bond-logo.png"
        alt="Bond Collective"
        className="h-9 md:h-10 w-auto"
        style={light ? { filter: "invert(1) brightness(2)" } : undefined}
      />
    </Link>
  );
};

export default Logo;
